{
	"title": "Failed Outbox Messages",
	"summary": {
		"title": "Message categories",
		"description": "Review the latest failed messages and analyze the payload before retriggering them.",
		"tabs": {
			"deposits": "Deposits",
			"invoices": "Invoices",
			"declarations": "Declarations"
		}
	},
	"table": {
		"id": "ID",
		"type": "Type",
		"status": "Status",
		"attemptsLeft": "Attempt",
		"data": "Data",
		"error": "Error",
		"created": "Created",
		"updated": "Updated",
		"actions": "Actions",
		"analyze": "Analyze",
		"statuses": {
			"ProcessingFailed": "Failed",
			"RetryScheduled": "Retry scheduled",
			"PendingRetry": "Pending retry",
			"Pending": "Pending"
		}
	},
	"copySuccess": "Message copied to clipboard",
	"refresh": "Refresh",
	"emptyState": "No failed {{category}} messages at the moment.",
	"analysisModal": {
		"title": "Analyze outbox message",
		"description": "Review the selected message details before retrying.",
		"loading": "Fetching analysis…",
		"emptyAnalysis": "Analysis unavailable for this message.",
		"retry": "Retry",
		"close": "Close",
		"empty": "Select a failed outbox message to inspect its details.",
		"flags": {
			"yes": "Yes",
			"no": "No",
			"unknown": "Unknown"
		},
		"fields": {
			"created": "Created",
			"updated": "Updated",
			"attemptsLeft": "Attempts left",
			"type": "Type",
			"error": "Error",
			"data": "Data",
			"suggestedAction": "Suggested action",
			"hederaSideEffects": "Hedera side effects suspected"
		}
	},
	"errors": {
		"fetch": "Failed to fetch outbox messages",
		"retry": "Failed to retry outbox message with ID {{id}}",
		"analyze": "Failed to analyze outbox message with ID {{id}}",
		"copy": "Unable to copy message, please try again."
	}
}
